<template>
<div class="content">

    <toolbar v-bind:selection="toolbar" title="Reinas" />

    <v-tabs>
        <v-tabs-slider color="orange"></v-tabs-slider>

        <v-tab @click="tabs.tab1 = true; tabs.tab2 = false">Activas ({{result.length}})</v-tab>
        <v-tab @click="tabs.tab1 = false; tabs.tab2 = true">Archivadas ({{completed.length}})</v-tab>
    </v-tabs>

    <div v-if="tabs.tab1===true">
        <!--
            <v-card-title>
                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        color="orange"
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="result"
                    :search="search"
                    :items-per-page="-1"

                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    show-expand
                    class="elevation-1"

            >

                <template v-slot:item.year="{ item }">
                    <span v-bind:class="'badge badge-'+item.color">{{ item.year }}</span>
                    <p v-if="item.color==='sin marcar'" class="text-red">Sin marcar</p>
                </template>

                <template v-slot:item.namecolmenar="{ item }">

                    <div v-if="item.namecolmenar">
                        {{item.namecolmenar}}
                    </div>
                    <div v-else>
                        -
                    </div>

                </template>

                <template v-slot:item.number="{ item }">
                    <div v-if="item.number">
                        {{item.number}}
                    </div>
                    <div v-else>
                        <router-link v-bind:to="'/ciclo-reina-nueva/'+item.id">
                            ASIGNAR COLMENA
                        </router-link>
                    </div>
                </template>

                <template v-slot:item.id="{ item }">

                    <a v-bind:href="'#/queen-detalle/' + item.id">
                        <v-icon color="grey">mdi-pencil</v-icon>
                    </a>

                </template>


                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" style="padding-top:8px; padding-bottom: 8px;">

                        <p class="vsm-header">ÚLTIMO CICLO REINA</p>
                        <span v-if="item.date!=''" >{{ item.date.split("-").reverse().join('-') }}</span>&nbsp;
                        <span v-if="item.cycle" class="let">{{ item.cycle }}</span> <span v-if="state" class="let">, {{ item.state }}</span>

                    </td>
                </template>


            </v-data-table>

-->


        <listqueens v-bind:result="result"></listqueens>
    </div>

    <div v-if="tabs.tab2===true">
        <listqueens v-bind:result="completed"></listqueens>
    </div>
    <menubottom active="2" />

</div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"
import listqueens from "@/components/queens/listqueens"

import axios from "axios";
export default {

  name: 'queens',
  components: {menubottom,toolbar,listqueens},
    data: () => ({

expanded: [],
        singleExpand: false,

    search: '',
    headers: [
          {
            text: 'Nombre',
            align: 'start',
            filterable: true,
            value: 'name',
          },
          { text: 'Año', value: 'year' },
          { text: 'Colmenar', value: 'namecolmenar' },
          { text: 'Colmena', value: 'number' },
          { text: 'Acciones', value: 'id' }
        ],

        toolbar: {
            return: '',
            icons: [
              { text: 'Añadir reina', href:'queen-nueva' },
              { text: 'Cancelar', href:'queens' }
            ],
        },

        tabs: {
            tab1: true,
            tab2: false,
        },

        completed: null,
        result: null,
  }),

  created() {
    auth.getUserLogged()
    var that = this
    axios.get("https://appws.panimiel.com/new/index.php/api/queens/0/0").then((result) => {
      that.result = result.data
    })

    axios.get("https://appws.panimiel.com/new/index.php/api/queens/0/1").then((completed) => {
      that.completed = completed.data
    })

  }

};


</script>

<style scoped lang="scss">
</style>